import { render, staticRenderFns } from "./HelpUsToImprove.vue?vue&type=template&id=e8451fbe&"
import script from "./HelpUsToImprove.vue?vue&type=script&lang=js&"
export * from "./HelpUsToImprove.vue?vue&type=script&lang=js&"
import style0 from "./HelpUsToImprove.vue?vue&type=style&index=0&id=e8451fbe&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports